import type { PlanItemState } from "@/lib/api";

const STYLES: Record<PlanItemState, { label: string; className: string }> = {
  PROPOSED: {
    label: "Proposed",
    className: "bg-curate-mist text-curate-ink border-curate-slate/25",
  },
  APPROVED: {
    label: "Approved",
    className: "bg-curate-success/10 text-curate-success border-curate-success/25",
  },
  REJECTED: {
    label: "Rejected",
    className: "bg-curate-danger/10 text-curate-danger border-curate-danger/25",
  },
  MODIFIED: {
    label: "Modified",
    className: "bg-curate-accent/15 text-curate-ink border-curate-accent/30",
  },
  EXECUTED: {
    label: "Executed",
    className: "bg-curate-primary/10 text-curate-primary border-curate-primary/25",
  },
  REVERTED: {
    label: "Reverted",
    className: "bg-curate-warn/10 text-curate-warn border-curate-warn/30",
  },
};

export function StateBadge({ state }: { state: PlanItemState }) {
  const s = STYLES[state];
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-2xs font-medium ${s.className}`}
    >
      {s.label}
    </span>
  );
}
